<script>
import {readAsImage, readAsPDF, readAsDataURL} from '../pdfEditor/utils/asyncReader'
import prepareAssets, {fetchFont} from '../pdfEditor/utils/prepareAssets'
import {save} from '../pdfEditor/utils/PDF'
import {generateId} from '../pdfEditor/utils/helper'
import PdfPage from "@/components/pdfEditorThamDinhVB/PdfPage";
import ObjectContainer from "@/components/pdfEditorThamDinhVB/ObjectContainer";
import {CURRENT_USER} from "@/helpers/currentUser";
import {vanBanDenModel} from "@/models/vanBanDenModel";
import {notifyModel} from "@/models/notifyModel";
import {signDigitalModel} from "@/models/signDigitalModel";
import {mapState} from "vuex";
import {required} from "vuelidate/lib/validators";
import LetterCube from "@/components/LetterCube";
import moment from "moment";
import Countdown from "@/components/Countdown/countdown";
import Switches from "vue-switches";

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {Countdown, ObjectContainer, PdfPage, LetterCube, Switches},
  props: {
    pdf: {
      required: false,
      type: String,
    },
    file: {required: false},
    fileInfo: {required: true}
  },
  validations: {
    modelTextSign: {
      content: {required},
    },
    signatureDigital:{
      content: {required},
      password: {required}
    }
  },
  data() {
    return {
      pages: [],
      pagesSize: [],
      allObjects: [],
      pagesScale: [],
      selectedPageIndex: 0,
      signatureCanvas: {
        isShow: false
      },
      opacity: 1,
      pdfFile: null,
      kySoModel: {
        userName: null,
        password: null,
        file: this.file,
        px: 0,
        py: 0,
        width: 0,
        height: 0,
        page: 0,
        image: null
      },
      test: null,
      currentUser: CURRENT_USER.USER_KY_SO,
      currentUserKySo: CURRENT_USER.USER_KY_SO,
      downloadFile: null,
      currentFont: "Times-Roman",
      signatureDigital: {
        vanBanDiId: null,
        userName: null,
        password: null,
        reject: false,
        content: null,
        signDigitals: [],
        scale: 1
      },
      model: vanBanDenModel.baseJson(),
      currentUserName: CURRENT_USER.USERNAME,
      showThemChuKyModal: false,
      imageChuKyMoc: null,
      lists: [
        {
          img: 'https://avatars2.githubusercontent.com/u/15681693?s=460&v=4'
        }
      ],
      option: {
        img: 'https://avatars2.githubusercontent.com/u/15681693?s=460&v=4',
        size: 1,
        full: true,
        outputType: 'png',
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 264,
        autoCropHeight: 100,
        centerBox: false,
        high: true,
        max: 99999
      },
      fixed: true,
      fixedNumber: [16, 9],
      previews: null,
      signatureSave: null,
      signatureVM: {
        userName: CURRENT_USER.USERNAME,
        action: null,
        signatureSaves: []
      },
      showModelNote: false,
      typeKySo: "KYNHAY",
      modelTextSign: {
        fontWeight: "normal",
        fontSize: 13,
        content: ""
      },
      submitted: false,
      resultData: {
        resultString: null,
        resultCode: null
      },
      isShowModalAfterThietLap: false,
      showModalHoanhThanhKySo: false,
      end: new Date(),
      trangThaiKySo: "Chờ xác nhận",
      trangThaiKySoCode: null,
      showModelAcceptKySo: false
    }
  },
  computed: {
    countPages() {
      if (this.pages)
        return this.pages.length;
      else return 0;
    },
    activePage() {
      return this.selectedPageIndex + 1
    },
    isShow() {
      if (this.$refs.signatureCanvas) {
        return this.$refs.signatureCanvas.isShow;
      }
      return false;
    },
    ...mapState('pdfEditorStore', ['scale','isFinish'])
  },
  watch: {
    selectedPageIndex(value) {
    },
  },
  async mounted() {
    this.signatureDigital.vanBanDiId = this.fileInfo.vanBanDiId;
    this.mountPdf()
  },
  methods: {
    async handleAssignOrReject() {
      this.submitted = true;
      this.$v.$touch();
      if(!this.signatureDigital.reject){
        if (this.$v.signatureDigital.password.$invalid) {
          return;
        }
      }else {
        if (this.$v.signatureDigital.$invalid) {
          return;
        }
      }

      this.handleClearResponse();
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      },{
        default: this.$createElement(LetterCube),
      });
      this.signatureDigital.vanBanDiId = this.$route.params.id;
      await this.$store.dispatch("signDigitalStore/thamDinhVanBan", this.signatureDigital).then((res) => {
        if (res.resultCode == 'SUCCESS') {
          this.resultData.resultCode = res.resultCode;
          this.resultData.resultString = res.resultString;
          this.isShowModalAfterThietLap = true;
        }else{
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }

      });
      loader.hide()
    },
    handleCloseHoanThanhKySoModal(){
      this.$router.push("/xu-ly-van-ban-di");
    },
    handleHideModal() {
      this.isShowModalAfterThietLap = false;
      this.$router.push('/xu-ly-van-ban-di')
    },
    handleClearResponse(){
      this.trangThaiKySoCode = null;
      this.trangThaiKySo = null;
    },
    async mountPdf() {
      try {
        const res = await fetch(this.fileInfo.path)
        console.log("tải file", res)
        const pdfBlob = await res.blob()
        await this.addPDF(pdfBlob)

        this.selectedPageIndex = 0

        setTimeout(() => {
          fetchFont('Times-Roman')
          prepareAssets()
        }, 5000)
      } catch (e) {
        console.log('Error:', e)
      }
    },

    async addPDF(file) {
      try {
        const pdf = await readAsPDF(file)
        this.pdfFile = file
        const numPages = pdf.numPages
        if (this.pages) {
          this.pages.splice(0, this.pages.length)
        }
        this.pages = Array(numPages).fill().map((_, i) => pdf.getPage(i + 1))

        this.pagesScale = Array(numPages).fill(1)
      } catch (e) {
        console.log('Failed to add pdf. Please try again.', e)
      }
    },

    onMeasure(scale, pageIndex) {
      this.pagesScale[pageIndex] = scale
    },

    selectPage(index) {
      this.selectedPageIndex = index;
    },

    onUpdateSizePage(payload, indexPage) {
      if (this.pagesSize == null) {
        this.pagesSize = []
      }
      var index = this.pagesSize.findIndex(x => x.page == indexPage);
      if (index == -1) {
        this.pagesSize.push({page: indexPage, heightPage: payload.height, widthPage: payload.width});
      } else {
        this.pagesSize[index].heightPage = Math.round(payload.height);
        this.pagesSize[index].widthPage = Math.round(payload.width);
      }
    },
    nextPage() {
      if (this.selectedPageIndex >= this.pages.length - 1)
        return;
      this.selectedPageIndex += 1;
      let element = document.getElementById('page-signature-' + this.selectedPageIndex);
      element.scrollIntoView({behavior: "smooth"});
    },
    previousPage() {
      if (this.selectedPageIndex <= 0)
        return;
      this.selectedPageIndex -= 1;
      let element = document.getElementById('page-signature-' + this.selectedPageIndex);
      element.scrollIntoView({behavior: "smooth"});
    },
  }
}


</script>
<template>
  <div class="tw-mb-4 tw-flex tw-flex-col tw-relative kyso-box">
    <b-card class="card-kyso">
      <div class="nav-kyso">
        <div class="d-flex row nav-kyso-box">
          <!--nav left-->
          <div class="d-flex col-lg-6 col-md-6 col-sm-12 content-nav-left">
            <div class="nav-kyso-left">
              <!--Số trang-->
              <div class="pdf-pages">
                <div class="icon-left px-2" @click="previousPage">
                  <i class="fas fa-arrow-left text-white"></i>
                </div>
                <div class="number-pages text-primary d-flex align-items-center">
                  <button class="btn btn-next text-primary">
                    {{ activePage }}
                  </button>
                  <div class="text-white mx-1">/</div>
                  <button class="btn btn-prev text-white">
                    {{ countPages }}
                  </button>
                </div>
                <div class="icon-left px-2" @click="nextPage">
                  <i class="fas fa-arrow-right text-white"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="tw-w-full tw-overflow-auto" style="overflow-y:auto; height: 80vh">
        <div
            v-for="(page, pageIndex) in pages"
            :key="pageIndex"
            class="tw-p-1 tw-w-full tw-flex tw-flex-col tw-items-center tw-overflow-hidden"
            @mousedown="() => selectPage(pageIndex)"
            @touchstart="() => selectPage(pageIndex)"
            :id="`page-signature-${pageIndex}`"
        >
          <div :class="['tw-relative tw-shadow-lg tw-mb-4', { 'selected-pdf': pageIndex == selectedPageIndex }]">
            <pdf-page @updateSizePage="(payload) => onUpdateSizePage(payload, pageIndex)" :page="pages[pageIndex]"
                      @measure="(payload) => onMeasure(payload, pageIndex)"/>
            <div

                class="tw-absolute tw-top-0 tw-left-0 tw-transform tw-origin-top-left"
                :style="{ transform: `scale(${pagesScale[pageIndex]})`, touchAction: 'none' }"
            >

            </div>
          </div>
        </div>
      </div>
    </b-card>
    <div class="footer-kyso d-flex justify-content-end">
      <button
          class="btn btn-danger px-5 fw-semibold me-2"
          @click="showModelAcceptKySo = true, signatureDigital.reject = true"
      >
        Từ chối
      </button>
      <button
          class="btn text-primary px-5 fw-semibold me-2"
          @click="showModelAcceptKySo = true, signatureDigital.reject = false"
          style="background-color: rgba(12, 92, 168, 0.1)"
      >
        Xác nhận
      </button>
    </div>

    <!--        Model xac nhận ký số-->
    <b-modal
        v-model="showModelAcceptKySo"
        centered
        title-class="font-18"
        no-close-on-backdrop
        hide-footer
        ref="formContainer"
    >
      <template #modal-header="{  }">
        <!-- Emulate built in modal header close button action -->
        <h5 style="font-weight: bold; font-size: 16px" > Thẩm định </h5>
        <div class="text-end">
          <b-button v-b-modal.modal-close_visit
                    size="sm"
                    class="btn btn-outline-info w-md"
                    v-on:click="showModelAcceptKySo = false">
            Đóng
          </b-button>
          <b-button v-if="!signatureDigital.reject" v-b-modal.modal-close_visit
                    size="sm"
                    variant="primary"
                    type="button"
                    class="w-md "
                    style="margin-left: 6px"
                    v-on:click="handleAssignOrReject">
            Đồng ý
          </b-button>
          <b-button v-if="signatureDigital.reject" v-b-modal.modal-close_visit
                    size="sm"
                    variant="danger"
                    type="button"
                    class="w-md"
                    style="margin-left: 6px"
                    v-on:click="handleAssignOrReject">
            Từ chối
          </b-button>
        </div>
      </template>

      <div class="row" ref="modalAcceptKySo">
        <div class="col-md-12 mt-2">
          <label class="form-label" for="validationCustom01"> Mật khẩu</label> <span
            class="text-danger">(*)</span>
          <input
              id="validationCustom01"
              v-model="signatureDigital.password"
              type="password"
              class="form-control"
              :class="{
                                'is-invalid':
                                  submitted && $v.signatureDigital.password.$error,
                                }"
        />
          <div
              v-if="submitted && !$v.signatureDigital.password.required"
              class="invalid-feedback"
          >
           Mật khẩu không được để trống.
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <label class="form-label" for="validationCustom01"> Nội dung</label>
          <span v-if="signatureDigital.reject"
            class="text-danger">(*)</span>
          <textarea
              id="validationCustom01"
              v-model="signatureDigital.content"
              type="text"
              class="form-control"
              :class="{
                                'is-invalid':
                                   signatureDigital.reject && submitted && $v.signatureDigital.content.$error,
                                }"
          ></textarea>
          <div
              v-if="signatureDigital.reject && submitted && !$v.signatureDigital.content.required"
              class="invalid-feedback"
          >
            Nội dung không được để trống.
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Model Notify   -->
    <b-modal
        v-model="isShowModalAfterThietLap"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        hide-header
        centered
        no-close-on-backdrop
        size="md"
        style="padding: 0px"
    >
      <Transition name="fade" mode="out-in">
        <div class="row justify-content-center">
          <div class="col-md-12"
               style="display: flex; justify-content: center; align-items: center; padding: 40px 40px; flex-direction: column;">
            <!--                <i class='bx bx-check-circle h1 text-success' style="font-size: 100px; margin-bottom: 40px"></i>-->
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
            <h1 v-if="resultData" class="fw-bold fs-3 text-dark text-uppercase">{{resultData.resultString}}</h1>
            <button type="button" v-on:click="handleHideModal" class="btn btn-modal text-uppercase"
                    style="width: 200px; margin-top: 20px; border-radius: 30px">Trở về
            </button>
          </div>
        </div>
      </Transition>
    </b-modal>
  </div>
</template>
<style>
body {
  margin: 0;
  height: 100%;
  /*overflow: hidden;*/
}

.selected-pdf {
  box-shadow: 0 0 0 1px rgba(52, 117, 224, 0.5);
  border: 1px #14b0ef solid;
}

.slider-blue {
  --slider-connect-bg: #3475e0;
  --slider-tooltip-bg: #3475e0;
  --slider-handle-ring-color: #3475e0;
}

.nav-kyso-box {
  justify-content: flex-start;
}

.modal-hoanhthanhkyso {
  background-color: transparent !important;
}

@media only screen and (max-width: 425px) {
  .nav-kyso-box {
    flex-direction: column-reverse;
    justify-content: center;
  }

  .content-nav-left {
    justify-content: center;
  }

  .nav-kyso-right {
    justify-content: center !important;
  }

}
</style>

<style lang="scss">
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;

  .check-icon {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #4CAF50;

    &::before {
      top: 3px;
      left: -2px;
      width: 30px;
      transform-origin: 100% 50%;
      border-radius: 100px 0 0 100px;
    }

    &::after {
      top: 0;
      left: 30px;
      width: 60px;
      transform-origin: 0 50%;
      border-radius: 0 100px 100px 0;
      animation: rotate-circle 4.25s ease-in;
    }

    &::before, &::after {
      content: '';
      height: 100px;
      position: absolute;
      background: #FFFFFF;
      transform: rotate(-45deg);
    }

    .icon-line {
      height: 5px;
      background-color: #4CAF50;
      display: block;
      border-radius: 2px;
      position: absolute;
      z-index: 10;

      &.line-tip {
        top: 46px;
        left: 14px;
        width: 25px;
        transform: rotate(45deg);
        animation: icon-line-tip 0.75s;
      }

      &.line-long {
        top: 38px;
        right: 8px;
        width: 47px;
        transform: rotate(-45deg);
        animation: icon-line-long 0.75s;
      }
    }

    .icon-circle {
      top: -4px;
      left: -4px;
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      border: 4px solid rgba(76, 175, 80, .5);
    }

    .icon-fix {
      top: 8px;
      width: 5px;
      left: 26px;
      z-index: 1;
      height: 85px;
      position: absolute;
      transform: rotate(-45deg);
      background-color: #FFFFFF;
    }
  }
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
.kyso-box {
  & .card-kyso {

    & .card-body {
      padding: 0px;
      position: relative;

      & .nav-kyso {
        background-color: #0C5CA8;
        position: fixed;
        top: 70px;
        z-index: 1000;
        width: 100%;
        width: -webkit-fill-available;

        & .nav-kyso-box {
          & .nav-kyso-left {
            display: flex;
            align-items: center;
            padding: 5px;

            & .pdf-pages {
              display: flex;
              align-items: center;

              & .number-pages {
                & .btn-next {
                  background-color: #fff;
                }

                & .btn-prev {
                }
              }
            }

            & .pdf-zoom {
              display: flex;
              align-items: center;

              & .btn-number-zoom {
                background-color: #fff;
                color: #2a2a2a;
              }

            }

            & .nav-line {
              position: relative;

              &:before {
                content: "";
                display: block;
                width: 1px;
                height: 30px;
                color: #fff;
                background-color: #fff;
                margin: 0px 10px;
              }
            }

          }

          & .nav-kyso-right {
            justify-content: flex-end;

            & .dropdown {
              & .btn {
                background-color: #fff;
                border-radius: 5px;
              }

              & .dropdown-menu {
                & .btn-chuky,
                & .btn-kynhay,
                & .btn-kysophaply,
                & .btn-kynhay {
                  background-color: rgba(48, 130, 201, 0.1);
                  display: flex;
                  align-items: flex-end;
                  align-content: flex-end;
                  justify-content: center;
                  padding-top: 10px;
                  border-radius: 5px;
                }

                & .btn-kynhay {

                }

                & .btn-kysophaply {
                }
              }

              & .chuky-box {
                border: 1px dotted #ccc;
                height: 80px;
                min-height: 80px;
                width: 250px;
                min-width: 250px;
                border-radius: 5px;
                margin-top: 10px;
              }

              & .btn-selected {
                background-color: rgba(204, 204, 204, 0.5);
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;

                &:hover {
                  background-color: #005990;
                  color: #fff;
                }
              }

              & .btn-delete {
                background-color: rgba(204, 204, 204, 0.2);
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;

                &:hover {
                  background-color: #e72529;
                  color: #fff;
                }
              }
            }

            & .btn-ghichu,
            & .btn-kysophaply {
              background-color: #3082c9;
              color: #fff;
              margin: 10px 5px;
            }

            & .btn-download {
              background-color: #fff;
              border-color: #2a2a2a;
              margin: 10px 5px;
            }
          }
        }

      }
    }
  }
}

.btn-note-box {
  position: absolute;

}

.footer-kyso {
  position: fixed;
  bottom: 0;
  z-index: 1000;
  background-color: #f5f5f5;
  width: 100%;
  width: -webkit-fill-available;
  padding: 10px 0px;
}

.bg-xacnhankyso {
  background-color: #F7F6F9;
}

</style>


<style src="../../assets/tailwind.css"/>
